export default {
  selectedEventState: state => state.selectedEventState
}
